import {createStore, applyMiddleware} from 'redux'
import thunk from 'redux-thunk'
import reducer from './reducer'

export default () => {
  return createStore(
    reducer,
    applyMiddleware(thunk)
  );
}


// WEBPACK FOOTER //
// ./src/store/createStore.js